import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const PopupAside = ({children, visible, width, title}) => visible && (
  <aside className="popup-aside depth-5" style={{width: width}}>
    <h3>{title}</h3>
    <div className="popup">
      {children}
    </div>
  </aside>
);

export const PopupAsideCustom = ({children, visible, width, title}) => (
  <aside className={`popup-aside ${!visible ? 'd-none' : ''} depth-5`} style={{width: width}}>
    <h3>{title}</h3>
    <div className="popup">
      {children}
    </div>
  </aside>
)

PopupAside.defaultProps = {
  width: '280px',
};

PopupAside.propTypes = {
  children: PropTypes.element,
  visible: PropTypes.bool.isRequired,
  width: PropTypes.string,
};

export default PopupAside;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PopupAside/index.js